import { Capacitor } from '@capacitor/core';

/**
 * Detect if we're running inside a Capacitor native shell.
 * Returns the platform string ('ios' | 'android' | 'web').
 */
export function getCapacitorPlatform(): 'ios' | 'android' | 'web' {
  if (!Capacitor.isNativePlatform()) return 'web';
  return Capacitor.getPlatform() as 'ios' | 'android';
}

export function isCapacitorNative(): boolean {
  return Capacitor.isNativePlatform();
}

export function isCapacitorIOS(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
}

export function isCapacitorAndroid(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
}

/**
 * Apply platform-specific CSS classes to <html> element.
 * Call once at app startup. Only adds classes when inside Capacitor.
 *
 * Classes added:
 *  - `capacitor-native`  → any native shell
 *  - `capacitor-ios`     → iOS native
 *  - `capacitor-android` → Android native
 */
export function applyCapacitorClasses(): void {
  if (!Capacitor.isNativePlatform()) return;

  const root = document.documentElement;
  root.classList.add('capacitor-native');

  const platform = Capacitor.getPlatform();
  if (platform === 'ios') {
    root.classList.add('capacitor-ios');
  } else if (platform === 'android') {
    root.classList.add('capacitor-android');
  }
}
